import { type FormData, type GroupOptions, COMPONENT_TYPE_CHECKBOX } from '@entities/leadCollector';

export type CheckboxGroup = GroupOptions & { instanceId: string };

export function getCheckboxesFromBodyForm(bodyForm: FormData | null | undefined): CheckboxGroup[] {
  if (!bodyForm?.components?.length) return [];

  const result: CheckboxGroup[] = [];
  for (const c of bodyForm.components) {
    if (c.type === COMPONENT_TYPE_CHECKBOX && c.properties != null) {
      result.push({ ...(c.properties as unknown as GroupOptions), instanceId: c.instanceId });
    }
  }

  return result;
}
